// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","headerContainer":"Header_headerContainer__Gze82","logo":"Header_logo__shVBB","mainNav":"Header_mainNav__p+blE"};